/* eslint-disable import/no-cycle */
import { Util } from '@libs/utilities/util';

import { AMAZON_SALES_ESTIMATIONS, EnumAmazonMarketplace, IAmazonCompositeKeywordData, IAmazonSalesEstimations } from '../../../constants/research';
import { KEYWORD_PRODUCT_COUNT } from '../keyword-evaluation.config';


export class NicheEvaluatorService {


	totalRevenueTop3Pages(keywordData: IAmazonCompositeKeywordData): number {

		//0 - calculate the total revenue
		const totalSales		: number = this.salesEstimation(keywordData.marketplace).totalSales(keywordData.amazon.competition.reviews.count.avg);
		const avgProductRevenue	: number = totalSales * keywordData.amazon.competition.price.avg;
		const totalRevenue		: number = Math.round(avgProductRevenue * KEYWORD_PRODUCT_COUNT.TOP_3_PAGES * this.suggestionFactor(keywordData));

		//1 - obfuscate the value
		const obfuscatedTotalRevenue: number = Util.Crypto.obfuscateBy10Percent(totalRevenue);
		return obfuscatedTotalRevenue;
	}

	totalSalesByTop3Pages(keywordData: IAmazonCompositeKeywordData): number {

		//0 - calculate the total sales
		const avgProductTotalSales: number = this.salesEstimation(keywordData.marketplace).totalSales(keywordData.amazon.competition.reviews.count.avg);
		const totalSalesTop3Pages : number = Math.round(avgProductTotalSales * KEYWORD_PRODUCT_COUNT.TOP_3_PAGES * this.suggestionFactor(keywordData));

		//1 - obfuscate the value
		const obfuscatedTotalSales: number = Util.Crypto.obfuscateBy10Percent(totalSalesTop3Pages);
		return obfuscatedTotalSales;
	}

	totalSalesPage1(keywordData: IAmazonCompositeKeywordData): number {

		//0 - calculate the total revenue
		const page1AvgProductClothingSales: number = this.salesEstimation(keywordData.marketplace).salesPerMonthMba(keywordData.amazon.competition.reviews.count.page1);
		const totalSalesPage1 			  : number = Math.round(page1AvgProductClothingSales * KEYWORD_PRODUCT_COUNT.PAGE_1 * this.suggestionFactor(keywordData));

		//1 - obfuscate the value
		const obfuscatedTotalSalesPage1: number = Util.Crypto.obfuscateBy10Percent(totalSalesPage1);
		return obfuscatedTotalSalesPage1;
	}


	/**------------------------------------------------------
	 * Helper Functions
	 */
	salesEstimation(marketplace: EnumAmazonMarketplace): IAmazonSalesEstimations {

		//0 - get the sales estimator
		const estimation = AMAZON_SALES_ESTIMATIONS.find((salesEstimation: IAmazonSalesEstimations) => salesEstimation.marketplace === marketplace);
		if (!estimation) throw new Error(`NicheEvaluatorService => salesEstimation => FATAL ERROR: no sales estimation function was defined for the marketplace of "${marketplace}"`);

		//1 - return the estimation
		return estimation;
	}

	private suggestionFactor(keywordData: IAmazonCompositeKeywordData): number {
		return keywordData.amazon.suggestions.length / 50;
	}
}
